export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : (hour <= 11 ? '上午好' : (hour <= 13 ? '中午好' : (hour < 20 ? '下午好' : '晚上好')))
}

export function welcome() {
  const arr = ['休息一会儿吧', '准备吃什么呢?', '要不要打一把 DOTA', '我猜你可能累了']
  const index = Math.floor((Math.random()*arr.length))
  return arr[index]
}

/**
 * 触发 window.resize
 */
export function triggerWindowResizeEvent() {
  const event = document.createEvent('HTMLEvents')
  event.initEvent('resize', true, true)
  event.eventType = 'message'
  window.dispatchEvent(event)
}

/**
 * Remove loading animate
 * @param id parent element id or class
 * @param timeout
 */
export function removeLoadingAnimate(id = '', timeout = 1500) {
  if (id === '') {
    return
  }
  setTimeout(() => {
    document.getElementById(id).remove()
  }, timeout)
}
export const deepmerge={
  merge(...args) {
    let options, name, src, srcType, copy, copyIsArray, clone,
    target = args[0] || {},
    i = 1
    const length = args.length
    let deep = false
    if ( typeof target === 'boolean') {
        deep = target
        target = args[i] || {}
        i++
    }
    if ( typeof target !== 'object' && typeof target !== 'function') {
        target = {}
    }
    if ( i === length) {
        target = this
        i--
    }
    for ( ; i < length; i++ ) {
        if ( (options = args[i]) !== null ) {
            for ( name in options ) {
                src = target[name]
                copy = options[name]
                if ( target === copy ) {
                    continue
                }
                srcType = Array.isArray(src) ? 'array': typeof src
                if ( deep && copy && ((copyIsArray = Array.isArray(copy)) || typeof copy === 'object')) {
                    if ( copyIsArray ) {
                        copyIsArray = false
                        clone = src && srcType === 'array' ? src : []
                    } else {
                        clone = src && srcType === 'object' ? src: {}
                    }
                    target[name] = this.merge(deep, clone, copy)
                } else if ( copy !== undefined ) {
                    target[name] = copy
                }
            }
        }
    }
    return target
  }
}